import Icon from '../components/Icon.vue'

Icon.register({
  download: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M216 0h80c13.3 0 24 10.7 24 24v168h87.7c17.8 0 26.7 21.5 14.1 34.1l-152.1 152.2c-7.5 7.5-19.8 7.5-27.3 0l-152.3-152.2c-12.6-12.6-3.7-34.1 14.1-34.1h87.8v-168c0-13.3 10.7-24 24-24zM512 376v112c0 13.3-10.7 24-24 24h-464c-13.3 0-24-10.7-24-24v-112c0-13.3 10.7-24 24-24h146.7l49 49c20.1 20.1 52.5 20.1 72.6 0l49-49h146.7c13.3 0 24 10.7 24 24zM388 464c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20zM452 464c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20z'
      }
    ]
  }
})



// WEBPACK FOOTER //
// ./~/vue-awesome/icons/download.js